import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Title(props: { children: ReactNode; className?: string; size?: 'default' | 'lg' }) {
	return <h1 className={cn(props.size === 'lg' && 'text-3xl font-medium', props.className)}>{props.children}</h1>;
}
